// Mirrors the cancel route's body rule: the reason is trimmed, then must be 1-2000 characters.
export const MAX_CANCEL_REASON_LENGTH = 2000;

export type CancelReasonValidation = { ok: true; reason: string } | { ok: false; error: string };

export function validateCancelReason(raw: string): CancelReasonValidation {
    const reason = raw.trim();
    if (reason.length === 0) {
        return { ok: false, error: 'Add a reason for canceling this VA.' };
    }
    if (reason.length > MAX_CANCEL_REASON_LENGTH) {
        return {
            ok: false,
            error: `Keep the reason to ${MAX_CANCEL_REASON_LENGTH} characters or fewer.`
        };
    }
    return { ok: true, reason };
}
